import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRoleIndexState() {
  return useAppState();
}

export function useRoleIndexActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      roles: [],
      roleModalIsOpen: false,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openRoleModal() {
    dispatch((appState) => ({
      ...appState,
      roleModalIsOpen: true,
    }));
  }

  function closeRoleModal() {
    dispatch((appState) => ({
      ...appState,
      roleModalIsOpen: false,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openRoleModal,
    closeRoleModal,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
